//export enum SituacaoEnum {
export class SituacaoEnum {
  public static Inscrito={id:1, descricao:"Inscrito"};
  public static IndeferidoTecnico={id:2, descricao:"Indeferido 1ª Etapa"};
  public static IndeferidoAcademico={id:3, descricao:"Indeferido 2ª Etapa"};
  public static DeferidoTecnico={id:4, descricao:"Deferido 1ª Etapa"};
  public static DeferidoAcademico={id:5, descricao:"Deferido 2ª Etapa"};
  public static Deferido={id:6, descricao:"Deferido"};
  public static PrestacaoContas={id:7, descricao:"Prestação de Contas"};
  public static PrestacaoNaoAprovada={id:8, descricao:"Prestação de Contas Não Aprovada"};
  public static Finalizada={id:9, descricao:"Finalizada"};

  /*
  Inscrito = 1,
  IndeferidoTecnico = 2,
  IndeferidoAcademico =3,
  DeferidoTecnico=4,
  DeferidoAcademico=5,
  Deferido=6,
  PrestacaoContas=7,
  PrestacaoNaoAprovada=8,
  Finalizada=9
  */
}
